
$(document).ready(function() {
  var elem = document.querySelector("#terrazasMapaVue");
  if (elem == null) {
    return;
  }

  var mapaIniciado = false

  const renderer = {
    render({ count, position }) {
      const color = '#EF5949'

      const svg = window.btoa(`
                        <svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 160 160">
                          <circle cx="80" cy="80" opacity="1" r="80" />
                        </svg>`);

      // create marker using svg icon
      return new google.maps.Marker({
        position,
        icon: {
          url: `data:image/svg+xml;base64,${svg}`,
          scaledSize: new google.maps.Size(45, 45),
        },
        label: {
          text: String(count),
          color: "rgba(255,255,255,0.9)",
          fontSize: "16px",
        },
        // adjust zIndex to be above other markers
        zIndex: 1000 + count,
      });
    }
  }

  var vueAppTerrazasMapa;

  window.callbackFiltros = (form) => {
    vueAppTerrazasMapa.filtrarForm(form);
  }

  vueAppTerrazasMapa = new Vue({
    el: elem,
    data: {
      loader: false,
      filtros: {no_paginacion: true, fecha: null, lugar: null, tipo_evento_id: null, ordenar: null,},
      terrazas: []
    },
    computed: {
      urlParams(){
        let params = Object.assign({}, this.filtros)
        params = Object.fromEntries(Object.entries(params).filter(([_, v]) => (v != null && v != 'null')));
        delete params.no_paginacion
        return new URLSearchParams(params).toString()
      }
    },
    mounted() {
      try{
        if(window.location.search.length > 0){
          const searchParams = new URLSearchParams(window.location.search);
          const decodedParams = Array
            .from(searchParams.keys())
            .reduce((acc, key) => ({ ...acc, [key]: searchParams.get(key) }), {});
          this.filtros = {...this.filtros,...decodedParams}
        }
      }
      catch (error){
        ReportErrorLog(error)
        console.error(error)
      }
      this.getTerrazas()
    },
    methods: {
      getTerrazaUrl(terraza){
        let params = new URLSearchParams();
        if(this.filtros.fecha != null){
          params.set('fecha', this.filtros.fecha)
        }

        if(this.filtros.tipo_evento_id != null){
          params.set('tipo_evento_id', this.filtros.tipo_evento_id)
        }

        return '/terraza/' + terraza.slug + '_' + terraza.id + "?" + params.toString()
      },
      getTerrazas(mapaArea = null){
        if(mapaArea != null){
          this.filtros.mapa_area = mapaArea
        }
        if (this.loader) {
          return
        }
        this.loader = true
        axios
          .get('/terrazas-json', {
            params: this.filtros,
          })
          .then((response) => {
            vueAppTerrazasMapa.loader = false
            if (response.data.error) {
              swal({
                icon: "info",
                title: respuesta.data.error,
                button: {
                  text: "Aceptar",
                  closeModal: true,
                },
              })
              return
            }
            vueAppTerrazasMapa.terrazas = response.data.terrazas;
            for(let index in vueAppTerrazasMapa.terrazas){
              vueAppTerrazasMapa.terrazas[index].amenidades_cortas
                = vueAppTerrazasMapa.terrazas[index].amenidades_cortas.slice(0, 4)
            }
            if(mapaIniciado){
              generarPines();
            }
          })
          .catch((error) => {
            ReportErrorLog(error)
            console.error(error)
            vueAppTerrazasMapa.loader = false
            swal({
              icon: "info",
              title: "Ocurrió un error inesperado",
              button: {
                text: "Aceptar",
                closeModal: true,
              },
            })
          })
      },
      setOrden(orden){
        this.filtros.ordenar = orden;
        this.getTerrazas();
      },
      filtrarForm(form){
        let formData = new FormData(form)
        var object = {};
        formData.forEach(function(value, key){
          if(key.indexOf("[") > -1){
            let keyExtra = key.replace("[]", "");
            if(object[keyExtra] == null){
              object[keyExtra] = [];
            }
            object[keyExtra].push(value);
          }
          else{
            if(value.length > 0){
              object[key] = value;
            }
          }
        });

        this.filtros = {...this.filtros,...object}
        this.getTerrazas()
      }
    }
  });

  var mapa;
  const loader = new MapaLoader({
    apiKey: googleApiKey
  });

  var polygon
  loader.importLibrary("maps").then(({Map}) => {
    mapa = new Map(document.getElementById("mapa"), {
      center: { lat: 20.639417, lng: -103.345308 },
      zoom: 8,
      gestureHandling: "greedy",
      mapTypeControl: true,
      fullscreenControl: false,
      streetViewControl: true,
      draggableCursor: 'default',
      styles: window.MapaStyle
    });


    mapa.addListener("zoom_changed", (e) => {
      filtrarPorMapa();
    });

    mapa.addListener("dragend", (e) => {
      filtrarPorMapa();
    });

    generarPines()
    mapaIniciado = true
  });

  function filtrarPorMapa(){
    const bounds = mapa.getBounds();
    if(bounds == null){
      return
    }

    const ne = bounds.getNorthEast();
    const sw = bounds.getSouthWest();

    const nw = { lat: ne.lat(), lng: sw.lng() };
    const se = { lat: sw.lat(), lng: ne.lng() };

    const polygonCoords = [
      [nw.lat, nw.lng],
      [ne.lat(), ne.lng()],
      [se.lat, se.lng],
      [sw.lat(), sw.lng()]
    ];

    vueAppTerrazasMapa.getTerrazas(polygonCoords)
  }

  function generarPines(){
    let markers = []
    for (let index in vueAppTerrazasMapa.terrazas){
      let terraza = vueAppTerrazasMapa.terrazas[index];

      let marker = new google.maps.Marker({
        position: { lat: terraza.direccion_lat, lng: terraza.direccion_lng },
        map: mapa,
        title: terraza.nombre,
        icon: "/assets/imagenes/iconos/ic_pin_mapa.svg"
      });

      let precio = vueAppTerrazasMapa.$options.filters.moneda(terraza.precio);

      let html = '<a href="/terraza/'+terraza.slug+'_'+terraza.id+'"' +
        '       class="text-decoration-none pin-terraza-vertical">' +
        '        <div class="imagen">' +
        '            <img src="'+terraza.imagen_thumb+'" alt="'+terraza.nombre+'">' +
        '        </div>' +
        '        <div class="descripcion">' +
        '            <div class="titulo">' +
        '                <h4 class="titulo-terraza">'+terraza.nombre+'</h4>' +
        '                <p class="subtitulo-terraza">'+terraza.ciudad+'</p>' +
        '            </div>' +
        '            <div class="precio-resenia">' +
        '                <div class="d-flex justify-content-between align-items-center pe-2">' +
        '                    <span class="desde-precio">Desde</span>' +
        '                    <h4 class="precio display-7">' +
        '                        ' + precio +
        '                        <span> por '+terraza.min_horas+' horas</span>' +
        '                    </h4>' +
        '                </div>' +
        '            </div>' +
        '        </div>' +
        '    </a>'

      const infoWindow = new google.maps.InfoWindow({
        content: html
      });

      marker.addListener('click', () => {
        infoWindow.open(mapa, marker);
      });

      markers.push(marker);
    }

    const markerCluster = new MarkerClusterer({map: mapa, markers: markers, renderer: renderer});
  }
});
